import React, { useState } from 'react';
import twitterLogo from '../images/twitterIcon.png';
import telegramLogo from '../images/telegramIcon.png';
import './header.css'

const CA = '0x96f5464bbf4b7488d48b6284cdd95063035688d0';

const Header = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(CA);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="header">
      <div className="header-top">
        <h1>ROBIN STOLE MY BIKE</h1>
        <div className="header-socials">
          <a href="https://x.com/Robinigg_">
            <img src={twitterLogo} alt="Twitter" style={imageStyle} />
          </a>
          <a href="https://t.me/RobinNigga">
            <img src={telegramLogo} alt="Telegram" style={imageStyle} />
          </a>
        </div>
      </div>
      <button className="ca-button" onClick={handleCopy} type="button">
        <span className="ca-label">CA:</span>
        <span className="ca-address">{CA}</span>
        <span className="ca-copy">{copied ? 'Copied!' : 'Copy'}</span>
      </button>
    </div>
  );
}

// Estilo para reducir el tamaño de las imágenes y añadir la animación en el hover
const imageStyle = {
  width: '100px', // Reducción del tamaño de la imagen
  height: '100px',
  transition: 'transform 0.3s ease', // Agrega una transición para el efecto hover
};

// Aplica la animación al hacer hover sobre la imagen
imageStyle[':hover'] = {
  transform: 'scale(1.1) rotate(360deg)', // Aumenta el tamaño de la imagen en un 10% y la rota 360 grados al hacer hover
};

export default Header;

